/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Box, TextField, useTheme } from '@mui/material';

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value,
  onChange,
  placeholder = 'Enter markdown content...',
}) => {
  const theme = useTheme();
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    setLocalValue(newValue);
    onChange(newValue);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <TextField
        multiline
        fullWidth
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder}
        sx={{
          flex: 1,
          '& .MuiInputBase-root': {
            height: '100%',
            alignItems: 'flex-start',
          },
          '& .MuiInputBase-input': {
            height: '100% !important',
            overflow: 'auto !important',
            fontFamily: 'monospace',
            fontSize: '14px',
            color: theme.palette.text.primary,
          },
        }}
        InputProps={{
          sx: {
            height: '100%',
          },
        }}
      />
    </Box>
  );
};
